import React from "react";
import { useLoaderData } from "react-router-dom";
import QuizDetails from "../QuizDetails/QuizDetails";

const Course_Quiz = () => {
  const quizData = useLoaderData();
  const quizs = quizData.data.questions;
  console.log(quizs);
  return (
    <div>
      <h3 className="text-center mt-4 fw-bold">
        Start-{quizData.data.name}
        <span className="text-primary">-Quiz</span>
      </h3>
      <div className="mx-md-5 mx-0 px-md-5 px-0">
        {quizs.map((quiz) => (
          <QuizDetails quiz={quiz} key={quiz.id}></QuizDetails>
        ))}
      </div>
    </div>
  );
};

export default Course_Quiz;
